import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import el from './el.json'

/**
 * Υποδομή i18n με τα ελληνικά ως μόνη ενεργή γλώσσα (§3).
 * Κανένα component δεν περιέχει hardcoded κείμενο (§13).
 */
export const resources = {
  el: { translation: el },
} as const

void i18n.use(initReactI18next).init({
  resources,
  lng: 'el',
  fallbackLng: 'el',
  interpolation: { escapeValue: false },
  returnNull: false,
})

export default i18n
